module.exports = __webpack_public_path__ + "files/7169b1aede09a9f38f180d408973ecaf.png";